export default __webpack_public_path__ + "static/river-sprint-dfb2192502e79392d6db1feae137ad5c.jpg";